'use strict';

var _tslib = require('./_tslib-17936c8d.js');
var Spacing = require('./Spacing-3105a516.js');
var React = require('react');
var styled = require('styled-components');
var ResponsiveSizes = require('./ResponsiveSizes-61db354a.js');
var styles = require('./styles-2eec2580.js');
var ArrowDown = require('./ArrowDown-74f74169.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var styled__default = /*#__PURE__*/_interopDefault(styled);

var _a, _b, _c, _d;
exports.TextSpacingType = void 0;
(function (TextSpacingType) {
    TextSpacingType["BETWEEN_SECTIONS_LARGE"] = "between_sections_large";
    TextSpacingType["BETWEEN_SECTIONS"] = "between_sections";
    TextSpacingType["BETWEEN_TITLE_AND_TEXT"] = "between_title_and_text";
    TextSpacingType["BETWEEN_CONTENT_AND_BUTTON_LARGE"] = "between_content_and_button_large";
    TextSpacingType["BETWEEN_CONTENT_AND_BUTTON"] = "between_content_and_button";
    TextSpacingType["BETWEEN_TITLE_AND_IMAGE"] = "between_title_and_image";
    TextSpacingType["BETWEEN_TITLE_AND_CONTENT"] = "between_title_and_content";
    TextSpacingType["BETWEEN_ITEM_AND_FOOTER"] = "between_item_and_footer";
    TextSpacingType["SMALLEST"] = "smallest";
    TextSpacingType["NONE"] = "none";
    //compact
    TextSpacingType["COMPACT_BETWEEN_SECTIONS_LARGE"] = "compact_between_sections_large";
    TextSpacingType["COMPACT_BETWEEN_SECTIONS"] = "compact_between_sections";
    TextSpacingType["COMPACT_BETWEEN_TITLE_AND_TEXT"] = "compact_between_title_and_text";
    TextSpacingType["COMPACT_BETWEEN_CONTENT_AND_BUTTON_LARGE"] = "compact_between_content_and_button_large";
    TextSpacingType["COMPACT_BETWEEN_CONTENT_AND_BUTTON"] = "compact_between_content_and_button";
    TextSpacingType["COMPACT_BETWEEN_TITLE_AND_IMAGE"] = "compact_between_title_and_image";
    TextSpacingType["COMPACT_BETWEEN_TITLE_AND_CONTENT"] = "compact_between_title_and_content";
    TextSpacingType["COMPACT_BETWEEN_ITEM_AND_FOOTER"] = "compact_between_item_and_footer";
    TextSpacingType["COMPACT_SMALLEST"] = "compact_smallest";
    TextSpacingType["COMPACT_NONE"] = "compact_none";
})(exports.TextSpacingType || (exports.TextSpacingType = {}));
var spacingSizes = (_a = {},
    _a[exports.TextSpacingType.BETWEEN_SECTIONS_LARGE] = 192,
    _a[exports.TextSpacingType.BETWEEN_SECTIONS] = 128,
    _a[exports.TextSpacingType.BETWEEN_TITLE_AND_TEXT] = 24,
    _a[exports.TextSpacingType.BETWEEN_CONTENT_AND_BUTTON_LARGE] = 64,
    _a[exports.TextSpacingType.BETWEEN_CONTENT_AND_BUTTON] = 48,
    _a[exports.TextSpacingType.BETWEEN_TITLE_AND_IMAGE] = 32,
    _a[exports.TextSpacingType.BETWEEN_TITLE_AND_CONTENT] = 72,
    _a[exports.TextSpacingType.BETWEEN_ITEM_AND_FOOTER] = 128,
    _a[exports.TextSpacingType.SMALLEST] = 8,
    _a[exports.TextSpacingType.NONE] = 0,
    //compact
    _a[exports.TextSpacingType.COMPACT_BETWEEN_SECTIONS_LARGE] = 144,
    _a[exports.TextSpacingType.COMPACT_BETWEEN_SECTIONS] = 96,
    _a[exports.TextSpacingType.COMPACT_BETWEEN_TITLE_AND_TEXT] = 16,
    _a[exports.TextSpacingType.COMPACT_BETWEEN_CONTENT_AND_BUTTON_LARGE] = 40,
    _a[exports.TextSpacingType.COMPACT_BETWEEN_CONTENT_AND_BUTTON] = 32,
    _a[exports.TextSpacingType.COMPACT_BETWEEN_TITLE_AND_IMAGE] = 24,
    _a[exports.TextSpacingType.COMPACT_BETWEEN_TITLE_AND_CONTENT] = 64,
    _a[exports.TextSpacingType.COMPACT_BETWEEN_ITEM_AND_FOOTER] = 96,
    _a[exports.TextSpacingType.COMPACT_SMALLEST] = 8,
    _a[exports.TextSpacingType.COMPACT_NONE] = 0,
    _a);
exports.TextType = void 0;
(function (TextType) {
    TextType["HEADING_XXLARGE"] = "heading_xxlarge";
    TextType["HEADING_XLARGE"] = "heading_xlarge";
    TextType["HEADING_LARGE"] = "heading_large";
    TextType["HEADING_MEDIUM"] = "heading_medium";
    TextType["HEADING_SMALL"] = "heading_small";
    TextType["HEADING_SMALL_BOLD"] = "heading_small_bold";
    TextType["HEADING_XSMALL"] = "heading_xsmall";
    TextType["SUBHEADING"] = "subheading";
    TextType["ITEM"] = "item";
    TextType["BODY_LARGE"] = "body_large";
    TextType["BODY_MEDIUM_BOLD"] = "body_medium_bold";
    TextType["BODY"] = "body";
    TextType["BODY_SMALL_BOLD"] = "body_small_bold";
    TextType["BODY_SMALL"] = "body_small";
    TextType["LABEL"] = "label";
    TextType["LABEL_UNDERLINED"] = "label_underlined";
    TextType["SUBTITLE"] = "subtitle";
    TextType["TAGLINE"] = "tagline";
    TextType["MICROTEXT"] = "microtext";
    //compact
    TextType["COMPACT_HEADING_XXLARGE"] = "compact_heading_xxlarge";
    TextType["COMPACT_HEADING_XLARGE"] = "compact_heading_xlarge";
    TextType["COMPACT_HEADING_LARGE"] = "compact_heading_large";
    TextType["COMPACT_HEADING_MEDIUM"] = "compact_heading_medium";
    TextType["COMPACT_HEADING_SMALL"] = "compact_heading_small";
    TextType["COMPACT_HEADING_SMALL_BOLD"] = "compact_heading_small_bold";
    TextType["COMPACT_HEADING_XSMALL"] = "compact_heading_xsmall";
    TextType["COMPACT_SUBHEADING"] = "compact_subheading";
    TextType["COMPACT_ITEM"] = "compact_item";
    TextType["COMPACT_BODY_LARGE"] = "compact_body_large";
    TextType["COMPACT_BODY_MEDIUM_BOLD"] = "compact_body_medium_bold";
    TextType["COMPACT_BODY"] = "compact_body";
    TextType["COMPACT_BODY_SMALL_BOLD"] = "compact_body_small_bold";
    TextType["COMPACT_BODY_SMALL"] = "compact_body_small";
    TextType["COMPACT_LABEL"] = "compact_label";
    TextType["COMPACT_LABEL_UNDERLINED"] = "compact_label_underlined";
    TextType["COMPACT_SUBTITLE"] = "compact_subtitle";
})(exports.TextType || (exports.TextType = {}));
var textSizes = (_b = {},
    _b[exports.TextType.HEADING_XXLARGE] = 72,
    _b[exports.TextType.HEADING_XLARGE] = 56,
    _b[exports.TextType.HEADING_LARGE] = 38,
    _b[exports.TextType.HEADING_MEDIUM] = 24,
    _b[exports.TextType.HEADING_SMALL] = 20,
    _b[exports.TextType.HEADING_SMALL_BOLD] = 20,
    _b[exports.TextType.HEADING_XSMALL] = 18,
    _b[exports.TextType.SUBHEADING] = 14,
    _b[exports.TextType.ITEM] = 14,
    _b[exports.TextType.BODY_LARGE] = 18,
    _b[exports.TextType.BODY_MEDIUM_BOLD] = 16,
    _b[exports.TextType.BODY] = 16,
    _b[exports.TextType.BODY_SMALL_BOLD] = 14,
    _b[exports.TextType.BODY_SMALL] = 14,
    _b[exports.TextType.LABEL] = 16,
    _b[exports.TextType.LABEL_UNDERLINED] = 16,
    _b[exports.TextType.SUBTITLE] = 12,
    _b[exports.TextType.TAGLINE] = 20,
    _b[exports.TextType.MICROTEXT] = 8,
    //compact
    _b[exports.TextType.COMPACT_HEADING_XXLARGE] = 48,
    _b[exports.TextType.COMPACT_HEADING_XLARGE] = 36,
    _b[exports.TextType.COMPACT_HEADING_LARGE] = 28,
    _b[exports.TextType.COMPACT_HEADING_MEDIUM] = 20,
    _b[exports.TextType.COMPACT_HEADING_SMALL] = 18,
    _b[exports.TextType.COMPACT_HEADING_SMALL_BOLD] = 18,
    _b[exports.TextType.COMPACT_HEADING_XSMALL] = 16,
    _b[exports.TextType.COMPACT_SUBHEADING] = 12,
    _b[exports.TextType.COMPACT_ITEM] = 14,
    _b[exports.TextType.COMPACT_BODY_LARGE] = 16,
    _b[exports.TextType.COMPACT_BODY_MEDIUM_BOLD] = 14,
    _b[exports.TextType.COMPACT_BODY] = 14,
    _b[exports.TextType.COMPACT_BODY_SMALL_BOLD] = 12,
    _b[exports.TextType.COMPACT_BODY_SMALL] = 12,
    _b[exports.TextType.COMPACT_LABEL] = 14,
    _b[exports.TextType.COMPACT_LABEL_UNDERLINED] = 14,
    _b[exports.TextType.COMPACT_SUBTITLE] = 12,
    _b);
var fontWeights = (_c = {},
    _c[exports.TextType.HEADING_XXLARGE] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.HEADING_XLARGE] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.HEADING_LARGE] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.HEADING_MEDIUM] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.HEADING_SMALL] = styles.FONT_WEIGHT.MEDIUM,
    _c[exports.TextType.HEADING_SMALL_BOLD] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.HEADING_XSMALL] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.SUBHEADING] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.ITEM] = styles.FONT_WEIGHT.MEDIUM,
    _c[exports.TextType.BODY_LARGE] = styles.FONT_WEIGHT.REGULAR,
    _c[exports.TextType.BODY_MEDIUM_BOLD] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.BODY] = styles.FONT_WEIGHT.REGULAR,
    _c[exports.TextType.BODY_SMALL_BOLD] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.BODY_SMALL] = styles.FONT_WEIGHT.REGULAR,
    _c[exports.TextType.LABEL] = styles.FONT_WEIGHT.MEDIUM,
    _c[exports.TextType.LABEL_UNDERLINED] = styles.FONT_WEIGHT.MEDIUM,
    _c[exports.TextType.SUBTITLE] = styles.FONT_WEIGHT.REGULAR,
    _c[exports.TextType.TAGLINE] = styles.FONT_WEIGHT.MEDIUM,
    _c[exports.TextType.MICROTEXT] = styles.FONT_WEIGHT.REGULAR,
    //compact
    _c[exports.TextType.COMPACT_HEADING_XXLARGE] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.COMPACT_HEADING_XLARGE] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.COMPACT_HEADING_LARGE] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.COMPACT_HEADING_MEDIUM] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.COMPACT_HEADING_SMALL] = styles.FONT_WEIGHT.MEDIUM,
    _c[exports.TextType.COMPACT_HEADING_SMALL_BOLD] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.COMPACT_HEADING_XSMALL] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.COMPACT_SUBHEADING] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.COMPACT_ITEM] = styles.FONT_WEIGHT.MEDIUM,
    _c[exports.TextType.COMPACT_BODY_LARGE] = styles.FONT_WEIGHT.REGULAR,
    _c[exports.TextType.COMPACT_BODY_MEDIUM_BOLD] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.COMPACT_BODY] = styles.FONT_WEIGHT.REGULAR,
    _c[exports.TextType.COMPACT_BODY_SMALL_BOLD] = styles.FONT_WEIGHT.BOLD,
    _c[exports.TextType.COMPACT_BODY_SMALL] = styles.FONT_WEIGHT.REGULAR,
    _c[exports.TextType.COMPACT_LABEL] = styles.FONT_WEIGHT.MEDIUM,
    _c[exports.TextType.COMPACT_LABEL_UNDERLINED] = styles.FONT_WEIGHT.MEDIUM,
    _c[exports.TextType.COMPACT_SUBTITLE] = styles.FONT_WEIGHT.REGULAR,
    _c);
var lineHeights = {
    heading_xxlarge: 130,
    heading_xlarge: 130,
    heading_large: 130,
    heading_medium: 130,
    heading_small: 130,
    heading_small_bold: 130,
    heading_xsmall: 150,
    subheading: 150,
    item: 150,
    body_large: 150,
    body_medium_bold: 150,
    body: 150,
    body_small_bold: 150,
    body_small: 150,
    label: 150,
    label_underlined: 150,
    subtitle: 150,
    tagline: 130,
    microtext: 150,
    //compact
    compact_heading_xxlarge: 130,
    compact_heading_xlarge: 130,
    compact_heading_large: 130,
    compact_heading_medium: 130,
    compact_heading_small: 130,
    compact_heading_small_bold: 130,
    compact_heading_xsmall: 150,
    compact_subheading: 150,
    compact_item: 150,
    compact_body_large: 150,
    compact_body_medium_bold: 150,
    compact_body: 150,
    compact_body_small_bold: 150,
    compact_body_small: 150,
    compact_label: 150,
    compact_label_underlined: 150,
    compact_subtitle: 150,
};
var typeToCompactMap = (_d = {},
    _d[exports.TextType.HEADING_XXLARGE] = exports.TextType.COMPACT_HEADING_XXLARGE,
    _d[exports.TextType.HEADING_XLARGE] = exports.TextType.COMPACT_HEADING_XLARGE,
    _d[exports.TextType.HEADING_LARGE] = exports.TextType.COMPACT_HEADING_LARGE,
    _d[exports.TextType.HEADING_MEDIUM] = exports.TextType.COMPACT_HEADING_MEDIUM,
    _d[exports.TextType.HEADING_SMALL] = exports.TextType.COMPACT_HEADING_SMALL,
    _d[exports.TextType.HEADING_SMALL_BOLD] = exports.TextType.COMPACT_HEADING_SMALL_BOLD,
    _d[exports.TextType.HEADING_XSMALL] = exports.TextType.COMPACT_HEADING_XSMALL,
    _d[exports.TextType.SUBHEADING] = exports.TextType.COMPACT_SUBHEADING,
    _d[exports.TextType.ITEM] = exports.TextType.COMPACT_ITEM,
    _d[exports.TextType.BODY_LARGE] = exports.TextType.COMPACT_BODY_LARGE,
    _d[exports.TextType.BODY_MEDIUM_BOLD] = exports.TextType.COMPACT_BODY_MEDIUM_BOLD,
    _d[exports.TextType.BODY] = exports.TextType.COMPACT_BODY,
    _d[exports.TextType.BODY_SMALL_BOLD] = exports.TextType.COMPACT_BODY_SMALL_BOLD,
    _d[exports.TextType.BODY_SMALL] = exports.TextType.COMPACT_BODY_SMALL,
    _d[exports.TextType.LABEL] = exports.TextType.COMPACT_LABEL,
    _d[exports.TextType.LABEL_UNDERLINED] = exports.TextType.COMPACT_LABEL_UNDERLINED,
    _d[exports.TextType.SUBTITLE] = exports.TextType.COMPACT_SUBTITLE,
    _d[exports.TextType.TAGLINE] = exports.TextType.TAGLINE,
    _d[exports.TextType.MICROTEXT] = exports.TextType.MICROTEXT,
    _d[exports.TextType.COMPACT_HEADING_XXLARGE] = exports.TextType.HEADING_XXLARGE,
    _d[exports.TextType.COMPACT_HEADING_XLARGE] = exports.TextType.HEADING_XLARGE,
    _d[exports.TextType.COMPACT_HEADING_LARGE] = exports.TextType.HEADING_LARGE,
    _d[exports.TextType.COMPACT_HEADING_MEDIUM] = exports.TextType.HEADING_MEDIUM,
    _d[exports.TextType.COMPACT_HEADING_SMALL] = exports.TextType.HEADING_SMALL,
    _d[exports.TextType.COMPACT_HEADING_SMALL_BOLD] = exports.TextType.HEADING_SMALL_BOLD,
    _d[exports.TextType.COMPACT_HEADING_XSMALL] = exports.TextType.HEADING_XSMALL,
    _d[exports.TextType.COMPACT_SUBHEADING] = exports.TextType.SUBHEADING,
    _d[exports.TextType.COMPACT_ITEM] = exports.TextType.ITEM,
    _d[exports.TextType.COMPACT_BODY_LARGE] = exports.TextType.BODY_LARGE,
    _d[exports.TextType.COMPACT_BODY_MEDIUM_BOLD] = exports.TextType.BODY_MEDIUM_BOLD,
    _d[exports.TextType.COMPACT_BODY] = exports.TextType.BODY,
    _d[exports.TextType.COMPACT_BODY_SMALL_BOLD] = exports.TextType.BODY_SMALL_BOLD,
    _d[exports.TextType.COMPACT_BODY_SMALL] = exports.TextType.BODY_SMALL,
    _d[exports.TextType.COMPACT_LABEL] = exports.TextType.LABEL,
    _d[exports.TextType.COMPACT_LABEL_UNDERLINED] = exports.TextType.LABEL_UNDERLINED,
    _d[exports.TextType.COMPACT_SUBTITLE] = exports.TextType.SUBTITLE,
    _d);
var defaultFontFamily = "'Manrope', -apple-system, Helvetica Neue, Arial, Segoe UI, sans-serif;";
var secondaryFontFamily = "\"Bevellier\", ".concat(defaultFontFamily);
var getCustomSpacing = function (customSpacing) {
    return Spacing.isUndefined(customSpacing) || customSpacing.length === 4 ? customSpacing : _tslib.__spreadArray(_tslib.__spreadArray([], _tslib.__read(customSpacing), false), _tslib.__read(customSpacing), false);
};
var Text = function (_a) {
    var type = _a.type, props = _tslib.__rest(_a, ["type"]);
    return (React__namespace.createElement(TextView, _tslib.__assign({ textType: type }, props), props.children));
};
var InlineText = function (_a) {
    var type = _a.type, props = _tslib.__rest(_a, ["type"]);
    return (React__namespace.createElement(TextView, _tslib.__assign({ textType: type }, props, { inline: true, display: "inline" }), props.children));
};
var textSelectors = 'h1, h2, h3, h4, h5, h6, span, div, p, small, a';
var getMargin = function (props, customSpacingPosition) {
    var customSpacing = getCustomSpacing(props.customSpacing);
    if (customSpacing && !Spacing.isUndefined(customSpacingPosition)) {
        // eslint-disable-next-line security/detect-object-injection
        return "0 0 ".concat(customSpacing[customSpacingPosition], "px");
    }
    if (props.spacingType) {
        return "0 0 ".concat(spacingSizes[props.spacingType], "px");
    }
    return '0';
};
var getCompactStyles = function (type, fontWeight) {
    var compactType = typeToCompactMap[type];
    return styled.css(templateObject_1$1 || (templateObject_1$1 = _tslib.__makeTemplateObject(["\n    font-size: ", "px;\n    font-weight: ", ";\n  "], ["\n    font-size: ", "px;\n    font-weight: ", ";\n  "])), textSizes[compactType], fontWeight !== null && fontWeight !== void 0 ? fontWeight : fontWeights[compactType]);
};
var TextView = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_4 || (templateObject_4 = _tslib.__makeTemplateObject(["\n  text-align: ", ";\n  ", "\n\n  > ", " {\n    display: ", ";\n    font-family: ", ";\n    font-size: ", "px;\n    font-weight: ", ";\n    line-height: ", "%;\n    color: ", ";\n    margin: ", ";\n    ", "\n\n    a {\n      display: inline;\n      color: ", ";\n      text-decoration: underline;\n    }\n\n    ", "\n  }\n"], ["\n  text-align: ", ";\n  ", "\n\n  > ", " {\n    display: ", ";\n    font-family: ", ";\n    font-size: ", "px;\n    font-weight: ", ";\n    line-height: ", "%;\n    color: ", ";\n    margin: ", ";\n    ", "\n\n    a {\n      display: inline;\n      color: ", ";\n      text-decoration: underline;\n    }\n\n    ", "\n  }\n"])), function (props) { return props === null || props === void 0 ? void 0 : props.align; }, function (props) { return (props.inline ? 'display: inline !important;' : undefined); }, textSelectors, function (props) { return (props === null || props === void 0 ? void 0 : props.display) || 'block'; }, function (props) { return (props.textType === exports.TextType.TAGLINE ? secondaryFontFamily : defaultFontFamily); }, function (props) { return textSizes[props.textType]; }, function (props) { var _a; return (_a = props.fontWeight) !== null && _a !== void 0 ? _a : fontWeights[props.textType]; }, function (_a) {
    var textType = _a.textType;
    return lineHeights["".concat(textType)];
}, function (props) { return (props === null || props === void 0 ? void 0 : props.color) || styles.themeColors.gray['90']; }, function (props) { return getMargin(props, 0); }, function (props) {
    return props.ellipsis && styled.css(templateObject_2$1 || (templateObject_2$1 = _tslib.__makeTemplateObject(["\n        overflow: hidden;\n        text-overflow: ellipsis;\n      "], ["\n        overflow: hidden;\n        text-overflow: ellipsis;\n      "])));
}, styles.themeColors.blue['60'], function (props) {
    return props.useCompact
        ? styled.css(templateObject_3$1 || (templateObject_3$1 = _tslib.__makeTemplateObject(["\n            @media ", " {\n              margin: ", ";\n            }\n            @media ", " {\n              margin: ", ";\n              ", "\n            }\n            @media ", " {\n              margin: ", ";\n            }\n            @media ", " {\n              margin: ", ";\n              ", "\n            }\n          "], ["\n            @media ", " {\n              margin: ", ";\n            }\n            @media ", " {\n              margin: ", ";\n              ", "\n            }\n            @media ", " {\n              margin: ", ";\n            }\n            @media ", " {\n              margin: ", ";\n              ", "\n            }\n          "])), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.LARGE_DESKTOP], getMargin(props, 3), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.DESKTOP], getMargin(props, 2), getCompactStyles(props.textType, props.fontWeight), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.TABLET], getMargin(props, 1), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.MOBILE], getMargin(props, 0), getCompactStyles(props.textType, props.fontWeight)) : undefined;
});
var templateObject_1$1, templateObject_2$1, templateObject_3$1, templateObject_4;

var Hyperlink = function (_a) {
    var _b;
    var className = _a.className, href = _a.href, inNewWindow = _a.inNewWindow, _c = _a.variant, variant = _c === void 0 ? 'default' : _c, children = _a.children, icon = _a.icon, rel = _a.rel, props = _tslib.__rest(_a, ["className", "href", "inNewWindow", "variant", "children", "icon", "rel"]);
    return (React__namespace.createElement(HyperlinkView, _tslib.__assign({ className: className, href: href, target: inNewWindow ? '_blank' : undefined, rel: rel, variant: variant }, props),
        children, (_b = (variant === 'navigation' && icon)) !== null && _b !== void 0 ? _b : React__namespace.createElement(ChevronRight, { "data-testid": "chevron-right", fill: styles.themeColors.blue['60'] })));
};
var ChevronRight = styled__default.default(ArrowDown.ArrowDown).withConfig({ displayName: "ChevronRight", componentId: "-9b708c" })(templateObject_1 || (templateObject_1 = _tslib.__makeTemplateObject(["\n  transform: rotate(-90deg);\n"], ["\n  transform: rotate(-90deg);\n"])));
var HyperlinkView = styled__default.default.a.withConfig({ displayName: "HyperlinkView", componentId: "-1rh4spx" })(templateObject_3 || (templateObject_3 = _tslib.__makeTemplateObject(["\n  display: inline-flex;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 24px;\n  text-decoration-line: ", ";\n  color: ", ";\n  transition: color ", "s;\n\n  @media ", ", ", " {\n    font-size: 14px;\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px ", ";\n    border-radius: 4px;\n  }\n\n  ", "\n"], ["\n  display: inline-flex;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 24px;\n  text-decoration-line: ", ";\n  color: ", ";\n  transition: color ", "s;\n\n  @media ", ", ", " {\n    font-size: 14px;\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px ", ";\n    border-radius: 4px;\n  }\n\n  ", "\n"])), function (props) { return (props.variant === 'default' ? 'underline' : 'none'); }, styles.themeColors.blue['60'], styles.transitionTime, ResponsiveSizes.media.desktop, ResponsiveSizes.media.mobile, function () { return styles.themeColors.blue['30']; }, function (props) {
    return props.variant === 'default' && styled.css(templateObject_2 || (templateObject_2 = _tslib.__makeTemplateObject(["\n      &:hover {\n        color: ", ";\n      }\n    "], ["\n      &:hover {\n        color: ", ";\n      }\n    "])), styles.themeColors.blue['40']);
});
var templateObject_1, templateObject_2, templateObject_3;

exports.Hyperlink = Hyperlink;
exports.InlineText = InlineText;
exports.Text = Text;
exports.textSelectors = textSelectors;
//# sourceMappingURL=Hyperlink-e5b9a045.js.map
